import React from 'react';
import Terms from '@/components/terms';

const TermsScreen = () => {
  return <Terms />;
};

export default TermsScreen;
